import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { setAccessToken } from 'src/app/store/actions/token.actions';
import { selectAccessToken, selectRefreshToken } from 'src/app/store/selectors/token.selectors';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ClubCarAuthGuard implements CanActivate {

  constructor(
    private cookieService: CookieService,
    private router: Router,
    private store: Store,
    private authService: AuthService,
  ){}
  accessToken$ = this.store.select(selectAccessToken)
  refreshToken$ = this.store.select(selectRefreshToken)

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (window.parent && window === window.parent) {
        this.router.navigate([''])
      } 
      let accessToken = this.cookieService.get('accessToken')
      let refreshToken = this.cookieService.get('refreshToken')
      let clientId = ''
      let courseId = ''
      let encodedData = route.queryParamMap.get('session')
      if(encodedData) {
        const decodedData = JSON.parse(atob(decodeURIComponent(encodedData ?? '')));
        if(decodedData.at) {
          accessToken = decodedData.at
          this.cookieService.set('accessToken', decodedData.at || '')
        }
        if(decodedData.rt) {
          refreshToken = decodedData.rt
          this.cookieService.set('refreshToken', decodedData.rt || '')
        }
        if(decodedData.cid) {
          clientId = decodedData.cid
          localStorage.setItem('clientId', decodedData.cid)
        }
      }

      if(!accessToken) {
        this.accessToken$.subscribe((data) => {
          accessToken = data ?? ''
        })
      }
      if(!refreshToken) {
        this.refreshToken$.subscribe((data) => {
          refreshToken = data ?? ''
        })
      }
      this.store.dispatch(setAccessToken({accessToken: accessToken, refreshToken: refreshToken}))
      if(!accessToken) {
        this.router.navigate(['/embed/login'])
        return false
      }
    return true;
  }
  
}
